<kendo-window
    [(state)]="windowState"
    [(width)]="windowWidth"
    [(height)]="windowHeight"
    (close)="close()"
>
    <kendo-window-titlebar>
        <app-window-titlebar
            [title]="customMessagesService.translate('icon_titre')"
            [(state)]="windowState"
            (closeWindow)="close()"
        ></app-window-titlebar>
    </kendo-window-titlebar>
    <p>{{ message() }}</p>
    <app-icon-list (iconClick)="onIconClick($event)" />
    <button
        type="button"
        (click)="close()"
    >
        {{ customMessagesService.translate('action_annuler') }}
    </button>
</kendo-window>
